<template>
    <v-dialog v-model="$store.state.estimates.deleteEstimateDialog" width="500">
        <v-card>
            <v-card-title class="red white--text" primary-title>Are you sure you want to delete this estimate?</v-card-title>
            <v-card-text>
                <h5 class="title">This action cannot be undone</h5>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="confirmDelete"><v-icon left>mdi-delete</v-icon>Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {EventBus} from "../../../EventBus";
    import {EstimatesHttp} from "../../../http/estimates";

    export default {
        name: "DeleteEstimateDialog",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            estimate: {
                get() {
                    return this.$store.state.estimates.activeEstimate;
                }
            }
        },
        methods: {
            closeDialog() {
                this.$store.dispatch('estimates/resetActiveEstimate');
                this.$store.dispatch('estimates/setDeleteEstimateDialog', false);
                this.$store.dispatch('estimates/setEstimates');
                this.$store.dispatch('estimates/setDrafts');
            },
            async confirmDelete() {
                this.isLoading = true;
                try {
                    await EstimatesHttp.deleteEstimate(this.estimate._id);
                    EventBus.$emit('message', {message: 'Estimate deleted successfully', type: 'success'});
                    await this.$store.dispatch('estimates/resetActiveEstimate');
                    await this.$store.dispatch('estimates/setDeleteEstimateDialog', false);
                    await this.$store.dispatch('estimates/setEstimates');
                    await this.$store.dispatch('estimates/setDrafts');
                } catch (e) {
                    EventBus.$emit('message', {message: e, type: 'error'});
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
